import ehafoKanbanLayout from '@/independentViews/ehafoKanban/layout'
import booksLayout from '@/independentViews/books/layout'
import storyManageLayout from '@/independentViews/storyManage/layout'
import mainLayout from '@/layout'

// 新题整理系统
export const questionNeatenRoute = {
  path: '/question_neaten',
  component: () => import('@/independentViews/questionNeaten/index'),
  hidden: true,
  meta: { title: '新题整理系统' },
}

// 知学云
export const ehafoKanbanRoute = {
  path: '/ehafo_kanban',
  component: ehafoKanbanLayout,
  meta: {
    title: '知学云',
    icon: '',
  },
  redirect: '/ehafo_kanban/index',
  hidden: true,
  children: [
    {
      path: 'index',
      name: 'ehafo_kanban_index',
      component: () => import('@/independentViews/ehafoKanban/index/index'),
      meta: {
        title: '知学云',
        viewport: 'user-scalable=no',
      },
    },
  ],
}

// 教材编辑系统
export const booksRoute = {
  path: '/books',
  component: booksLayout,
  meta: {
    title: '教材编辑系统',
    icon: '',
  },
  hidden: true,
  children: [
    {
      path: 'book_ocr_edit',
      name: 'books_book_ocr_edit',
      component: () => import('@/independentViews/books/bookOcrEdit/index'),
      meta: {
        title: '书籍OCR比对',
      },
    },
  ],
}

export const clinicalPathRoute = {
  path: '/clinical_path',
  component: () => import('@/independentViews/clinicalPathManage/index'),
  hidden: true,
  meta: { title: '临床路径管理' },
}

// 开发流程管理系统
export const storyManageRoute = {
  path: '/story_manage',
  component: storyManageLayout,
  meta: {
    title: '开发流程管理系统',
    icon: '',
  },
  redirect: '/story_manage/index',
  hidden: true,
  children: [
    {
      path: 'index',
      name: 'story_manage_index',
      component: () => import('@/independentViews/storyManage/index/index'),
      meta: {
        title: '开发流程管理系统',
      },
    },
    {
      path: 'report',
      name: 'story_manage_report',
      component: () => import('@/independentViews/storyManage/report/index'),
      meta: {
        title: '开发流程管理系统',
      },
    },
  ],
}

// 新版自研统计系统
export const newTrackRoute = {
  path: '/new_track',
  meta: {
    title: '新版统计分析系统',
    icon: 'line-chart-line',
    alwaysShow: true,
  },
  component: mainLayout,
  redirect: '/new_track/statistics_dashboard',
  // hidden: true,
  children: [
    {
      path: 'statistics_dashboard',
      component: () => import('@/independentViews/track/statisticsDashboard/index'),
      meta: {
        title: '数据看板',
      },
    },
    {
      path: 'event_list',
      component: () => import('@/independentViews/track/eventList/index'),
      meta: {
        title: '事件管理',
      },
    },
    {
      hidden: true,
      path: 'event_detail',
      component: () => import('@/independentViews/track/eventDetail/index'),
      meta: {
        title: '事件详情',
      },
    },
  ],
}
